export const WES_DEFAULT_CURRENCY_CODE = 'USD';
